var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Tooltip } from 'flowbite-react';
import { CheckIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import { Translate, t } from "../../../../../I18N";
import { Button, Modal, Table } from "../../../../Components/UI";















const permissionsByRole = [
{
  action: 'Create new entities and upload documents',
  admin: 'full',
  editor: 'full',
  collaborator: 'full'
},
{
  action: 'Create table of contents',
  admin: 'full',
  editor: 'full',
  collaborator: 'full'
},
{
  action: 'View entities',
  admin: 'full',
  editor: 'full',
  collaborator: 'partial'
},
{
  action: 'Edit metadata of entities',
  admin: 'full',
  editor: 'full',
  collaborator: 'partial'
},
{
  action: 'Delete entities and documents',
  admin: 'full',
  editor: 'full',
  collaborator: 'partial'
},
{
  action: 'Share edit access with other users',
  admin: 'full',
  editor: 'full',
  collaborator: 'partial'
},
{
  action: 'Create relationships and references',
  admin: 'full',
  editor: 'full',
  collaborator: 'partial'
},
{
  action: 'Share entities with the public',
  admin: 'full',
  editor: 'full',
  collaborator: 'none'
},
{
  action: 'Manage site settings and configuration',
  admin: 'full',
  editor: 'none',
  collaborator: 'none'
},
{
  action: 'Add/delete users and assign roles',
  admin: 'full',
  editor: 'none',
  collaborator: 'none'
},
{
  action: 'Configure filters',
  admin: 'full',
  editor: 'none',
  collaborator: 'none'
},
{
  action: 'Add/edit translations',
  admin: 'full',
  editor: 'none',
  collaborator: 'none'
},
{
  action: 'Configure templates ',
  admin: 'full',
  editor: 'none',
  collaborator: 'none'
},
{
  action: 'Create and edit thesauri',
  admin: 'full',
  editor: 'none',
  collaborator: 'none'
},
{
  action: 'Create relationship types',
  admin: 'full',
  editor: 'none',
  collaborator: 'none'
}];


const ActionHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "User Action");
const CollaboratorHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Collaborator");
const EditorHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Editor");
const AdminHeader = () => /*#__PURE__*/_jsx(Translate, {}, void 0, "Admin");

const LevelCell = ({ cell }) => {
  switch (cell.getValue()) {
    case 'full':
      return /*#__PURE__*/_jsx(CheckIcon, { className: "w-6 text-green-400" });

    case 'partial':
      return /*#__PURE__*/(
        _jsx(Tooltip, {
          content: t(
            'System',
            'Permission on entities explicitly shared with the user',
            null,
            false
          )
          // eslint-disable-next-line react/style-prop-object
          , style: "light" }, void 0, /*#__PURE__*/

        _jsx(UserPlusIcon, { className: "w-6 text-orange-400" })
        ));


    default:
      return /*#__PURE__*/_jsx(XMarkIcon, { className: "w-6 text-pink-600" });
  }
};

const ActionCell = ({ cell }) => /*#__PURE__*/
_jsx(Translate, {}, void 0, cell.getValue());


const columnHelper = createColumnHelper();
const tableColumns = [
columnHelper.accessor('action', {
  header: ActionHeader,
  cell: ActionCell,
  enableSorting: false,
  meta: { headerClassName: 'w-2/5' }
}),
columnHelper.accessor('collaborator', {
  header: CollaboratorHeader,
  cell: LevelCell,
  enableSorting: false,
  meta: { headerClassName: 'w-1/5' }
}),
columnHelper.accessor('editor', {
  header: EditorHeader,
  cell: LevelCell,
  enableSorting: false,
  meta: { headerClassName: 'w-1/5' }
}),
columnHelper.accessor('admin', {
  header: AdminHeader,
  cell: LevelCell,
  enableSorting: false,
  meta: { headerClassName: 'w-1/5' }
})];


const PermissionsListModal = ({ showModal, closeModal }) =>
showModal ? /*#__PURE__*/
_jsx(Modal, { size: "xxxl" }, void 0, /*#__PURE__*/
_jsx(Modal.Header, {}, void 0, /*#__PURE__*/
_jsx(Translate, { className: "text-xl font-medium text-gray-900" }, void 0, "Permissions"), /*#__PURE__*/
_jsx(Modal.CloseButton, { onClick: closeModal })
), /*#__PURE__*/
_jsx(Modal.Body, { className: "max-w-[100vw]" }, void 0, /*#__PURE__*/
_jsx(Table, { data: permissionsByRole, columns: tableColumns })
), /*#__PURE__*/
_jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
_jsx(Button, { className: "grow", styling: "light", onClick: closeModal }, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Close")
)
)
) :
null;

export { PermissionsListModal };